module.exports = __webpack_public_path__ + "static/media/sp.5b99e519.jpeg";